<script>
  import { onMount } from "svelte";

  let { ariaLabel = "Information", text = "Here's a tooltip!", onOpenGlossary = null, nudge = -2 } = $props();
  let isOpen = $state(false);
  let container = $state();

  /** @param {MouseEvent} event */
  function handleDocumentClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const glossaryLink = target.closest("[data-open-glossary]");
    if (glossaryLink) {
      event.preventDefault();
      isOpen = false;
      onOpenGlossary?.();
      return;
    }

    if (!isOpen) return;
    if (container && !container.contains(target)) {
      isOpen = false;
    }
  }

  /** @param {KeyboardEvent} event */
  function handleDocumentKeydown(event) {
    if (event.key === "Escape") {
      isOpen = false;
    }
  }

  function handleTriggerClick() {
    isOpen = !isOpen;
  }

  /** @param {KeyboardEvent} event */
  function handleTriggerKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      isOpen = !isOpen;
    }
  }

  function handleMouseEnter() {
    isOpen = true;
  }

  function handleMouseLeave() {
    isOpen = false;
  }

  onMount(() => {
    document.addEventListener("click", handleDocumentClick, true);
    document.addEventListener("keydown", handleDocumentKeydown);

    return () => {
      document.removeEventListener("click", handleDocumentClick, true);
      document.removeEventListener("keydown", handleDocumentKeydown);
    };
  });
</script>

<span class="container" bind:this={container} onmouseenter={handleMouseEnter} onmouseleave={handleMouseLeave} style="--icon-nudge: {nudge}px">
  <span
    role="button"
    tabindex="0"
    class="icon-btn"
    aria-label={ariaLabel}
    aria-expanded={isOpen}
    onclick={handleTriggerClick}
    onkeydown={handleTriggerKeydown}
  >
    <span class="circle">
      <span class="i">i</span>
    </span>
  </span>
  {#if isOpen}
    <div class="popup" role="tooltip">
      {@html text}
    </div>
  {/if}
</span>

<style>
  .container {
    display: inline;
    position: relative;
  }
  .icon-btn {
    display: inline;
    padding: 0 4px 0 0;
    cursor: pointer;
  }
  .circle {
    display: inline-flex;
    width: 14px;
    height: 14px;
    align-items: center;
    justify-content: center;
    background-color: var(--color-gray-shade-light);
    border-radius: 10px;
    vertical-align: baseline;
    position: relative;
    top: var(--icon-nudge);

    span.i {
      color: black;
      text-align: center;
      font-family: var(--font-family-sans-alt);
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    }
  }
  .popup {
    position: absolute;
    bottom: calc(100% + 4px);
    left: 50%;
    transform: translateX(-50%);
    width: 260px;
    background: white;
    border: 1px solid var(--color-gray);
    padding: 10px 12px;
    font-size: var(--font-size-small);
    line-height: var(--line-height-tight);
    color: var(--color-gray-shade-darkest);
    z-index: 500;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
    white-space: normal;
    word-wrap: break-word;
  }
</style>
